import { Box, SimpleGrid, useMantineTheme } from "@mantine/core";
import { useAtomValue } from "jotai";
import { colors } from "theme";

import Flex from "components/Flex";
import { CheckFilled as CheckIcon } from "components/Icons/CheckFilled";
import Text from "components/Text";

import { allDamagedPartsAtom } from "atoms/damageReview";
import { useClientTranslation } from "hooks/useClientTranslation";
import { CAR_PART_TRANSLATION_KEYS } from "types/CarPart";

import { useDamagedPartsList } from "./hooks/useDamagedPartsList";
import { useStyles } from "./styles";

export const DamagedPartsList = () => {
  const { t } = useClientTranslation();
  const allDamagedParts = useAtomValue(allDamagedPartsAtom);
  const { damagedParts, setDamagedPart } = useDamagedPartsList();
  const { classes } = useStyles();
  const { other } = useMantineTheme();
  const domain = window.location.host;

  return (
    <>
      <Text mx={24} sizeVariant="md">
        {t("damage_review.instruction")}
      </Text>
      <SimpleGrid className={classes.damagedPartsGrid} cols={2} mx={24} my={32}>
        {allDamagedParts.map((damagedPart) => {
          const selected: boolean = damagedParts.includes(damagedPart);

          return (
            <Box key={damagedPart} className={classes.damagedPartContainerWrapper}>
              <Flex
                className={classes.damagedPartContainer}
                onClick={() => setDamagedPart(damagedPart, !selected)}
                role="checkbox"
                aria-checked={selected}
                aria-labelledby={damagedPart}
                style={{
                  borderColor: selected ? other.primary[80] : colors.grey[30],
                  overflow: "hidden",
                }}
              >
                {selected && <CheckIcon className={classes.checkIcon} fill={other.primary[80]} />}

                <img src={`//${domain}/assets/svg/damageReview/${damagedPart}.svg`} alt={damagedPart} />
                <Text sizeVariant="md" weight={500} className={classes.damagedPartLabel} id={damagedPart}>
                  {t(CAR_PART_TRANSLATION_KEYS[damagedPart])}
                </Text>
              </Flex>
            </Box>
          );
        })}
      </SimpleGrid>
    </>
  );
};
